/* External Imports */
import { Box, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import forEach from 'lodash/forEach';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import config from '@config';

/* Services */
import { searchByFieldId } from '@components/Utility/Shared/SharedService';

/**
 * @description Renders the Yantra Interested for the program component
 * @returns {ReactElement} YantraTableModule component
 */

const InterestedForm = ({ formData, sectionid }) => {
  const eventId = formData[1]?.text;
  let programEventId = eventId;
  if (eventId?.indexOf('[envurl') > -1) {
    const updatedUrlArr = eventId
      .replace('][/envurl]', '')
      ?.replace('[envurl ', '')
      ?.split(' ');
    forEach(updatedUrlArr, function (upUrl) {
      if (config.ENV_NAME === 'production') {
        if (upUrl?.indexOf('prod=') > -1) {
            programEventId = upUrl.replace("prod='", '').replace("'", '');
        }
      } else {
        if (upUrl?.indexOf('uat=') > -1) {
            programEventId = upUrl.replace("uat='", '').replace("'", '');
        }
      }
    });
  }
  return (
    <>
        <Box bgColor="#FFF7E2" pt="30px">
          {/* IPRS Inline Form code snippet */}
          <Box id="interested-form-section" className='iprs-form' width={{base:'100%', lg:'1122px'}} m="0px auto" bgColor={'#5E1518'} pt="0px">
          <Box
            maxWidth={{ base: '', md: '998px', lg: '1120px' }}
            fontFamily="FedraSansStd-A-medium"
            mx="auto"
            as="h2"
            id="interestedform"
            width={{base: '90%', md:'617px'}}
            pt={{ base: '25px', md: '60px' }}
            >
                <Text
                    fontSize={{ base: '24px', md: '38px' }}
                    color="#ffffff"
                    textAlign="left"
                    fontWeight={'500'}
                    lineHeight={{base:'33.12px', md:'52.44px'}}
                    >
                    {formData[0]?.titleText}
                </Text>
                <Text
                    fontSize={{ base: '16px', md: '24px' }}
                    textAlign="left"
                    fontWeight={'350'}
                    color="#ffffff"
                    lineHeight={{base:'22.08px', md:'33.12px'}}
                >
                    {formData[0]?.titleSubtext}
                </Text>
                {searchByFieldId(formData, 'info-message') && (
                <>
                <Box lineHeight={'22px'} fontSize={'16px'} color={'#ffffff'}>
                    <StructuredTextParser
                        str={render(
                        searchByFieldId(formData, 'info-message').body
                        )}
                        fontFamily="FedraSansStd-book"
                        textAlign="left"
                        pb="5px"
                        mt="20px"
                        lineHeight="22px"
                        fontSize="16px"
                  />
                </Box>
                </>
                )}
            </Box>
            <Box id="my-react-component" className='inline-form' data-props={`{"isSeparateLinkShow":false, "eventId": ${programEventId}, "colorScheme":"yellow"}`}></Box>
          </Box>
            <style jsx global>
                {`
                .css-11geh0d {
                    font-family: FedraSansStd-medium,sans-serif !important;
                }
                .css-152bfrp, .css-4tl7lb, .css-1id6921 {
                    font-family: FedraSansStd-Book,sans-serif !important;
                }
                .css-n75q0x, .css-10w333y {
                    width: 617px;
                    margin: 0 auto !important;
                    padding: 30px 0 60px 0;
                }
                .css-10w333y {
                    max-height: 411px;
                    height: 411px;
                }
                .css-10w333y {
                    padding: 50px 0 50px 0;
                }
                .css-1rss8o5 {
                    min-height: 387px;
                    padding: 36px 66px !important;
                }
                .inline-form .css-kwu9rq {
                    grid-template-columns: repeat(1, 1fr);
                    padding: 20px 40px;
                }
                .css-10w333y hr {
                    border-bottom-width: 0px;
                    display: none;
                }
                .css-10w333y p {
                    font-family: FedraSansStd-book, sans-serif !important;
                    font-size: 16px;
                    line-height: 22px;
                    color: #433F3C;
                    text-align: center;
                    padding: 5px 0;
                }
                .css-10w333y h3 {
                    font-size: 20px;
                    color: #00A171;
                    padding-bottom: 5px;
                }
                .css-10w333y svg {
                    width: 81px;
                    height: 81px;
                }
                .css-ok4vqq {
                    height: auto !important;
                    padding: 60px 0 !important;
                }
                @media (max-width: 767px) {
                    .css-n75q0x, .css-10w333y {
                    width: 90%;
                    padding: 25px 0 30px 0 !important;
                    }
                    .css-10w333y {
                    height: 292px;
                    }
                    .css-1rss8o5 {
                    padding: 20px 16px !important; 
                    min-height: 360px;           
                    }
                    .inline-form .css-kwu9rq {
                    padding: 0px;
                    }
                    .css-10w333y h3 {
                    font-size: 18px;
                    }
                    .css-10w333y svg {
                    width: 40px;
                    height: 40px;
                    }
                }
                `}
            </style>
        </Box>
    </>
  );
};

export default InterestedForm;
